// Model.js
// -----------------------
// @module Case
define("Code25.CaterpartsGlobal.CloseAccount.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Main/SuiteScript2/CloseAccount.Service.ss"
            ),
            true
        )
});
});
